import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The filter bar above a list: search, filter/sort chips and the view switch on one row, so every
 * list screen narrows its rows the same way. Mark the search `esn-toolbar-search` (it takes the
 * free width) and trailing controls `esn-toolbar-end`; everything else goes between them.
 */
@Component({
  selector: 'esn-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {}
